import 'css-chunk:../pop-under-with-router/components/pop-under-with-router/index.module.scss';export default {
  "popunder": "_popunder_jnvfo_1",
  "popunder_white": "_popunder_white_jnvfo_8"
};